import { NgModule } from '@angular/core';
import { FormsModule }  from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ChartComponent } from './chart.component';
import { ChartRoutingModule } from './chart.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ChartRoutingModule,
  ],
  exports: [
    ChartComponent
  ],
  declarations: [
    ChartComponent
  ],
})
export class ChartModule { }
